"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _broadcast = require("./broadcast");
Object.keys(_broadcast).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _broadcast[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _broadcast[key];
    }
  });
});